const TAG_LINE = "Locally Owned and Operated";
export function localizationTagLine(){
    
    const tagLine = document.querySelector('.header-wrapper .description')as HTMLSpanElement;
    const dbaName = localStorage.getItem('dbaName');
    //replace the tage line even if the page is national provided the user is localized
    const existingTagLine = localStorage.getItem('localTagLine') ?? TAG_LINE;
    if(dbaName && existingTagLine && tagLine){
        tagLine.textContent = existingTagLine ?? TAG_LINE;
    }

}

export function localizationTagUpadation(){
    const localTagLine = localStorage.getItem('localTagLine')
    if(localStorage.getItem('dbaName')){
        let replaceText = localTagLine ?? TAG_LINE ;
        localStorage.setItem('localTagLine', replaceText);
    }
}